import TeamsIndex from './TeamsIndex';

export default TeamsIndex;
